module.exports = __webpack_public_path__ + "static/img/fourteen.8c87b9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/fourteen.png
// module id = ilih
// module chunks = 1